import {
    ADMIN_COUNTRY_MAPPING_COMPARE_SUCCESS,
    ADMIN_COUNTRY_MAPPING_COMPARE_FAILED,
    LOADING_ADMIN_COUNTRY_MAPPING_COMPARE,
    NETWORK_ERROR_ADMIN_COUNTRY_MAPPING_COMPARE,
    RESET_ADMIN_COUNTRY_MAPPING_COMPARE,

} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMIN_COUNTRY_MAPPING_COMPARE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMIN_COUNTRY_MAPPING_COMPARE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMIN_COUNTRY_MAPPING_COMPARE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMIN_COUNTRY_MAPPING_COMPARE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMIN_COUNTRY_MAPPING_COMPARE:
            return (state = initialState);
        default:
            return state;
    }
};